import React from 'react';
import { message } from "antd";

window.collectMsgTimeId = null;
export const successCollect = (action) => {
    let count = 5;
    const key = 'collectedSuccess';
    function updateMessage() {
        if (count === 0) {
            clearInterval(window.collectMsgTimeId);
            message.destroy(key);
        } else {
            count--;
            let content = <span>已收藏至"默认收藏夹"&nbsp;<a onClick={() => {
                action && action();
                message.destroy(key);
                clearInterval(window.collectMsgTimeId);
            }}>{`修改收藏位置(${count}S)`}</a>
            </span>;
            message.success({ content, key, duration: count });
        }
    }
    if (window.collectMsgTimeId) {
        clearInterval(window.collectMsgTimeId);
        window.collectMsgTimeId = null;
    }
    window.collectMsgTimeId = setInterval(updateMessage, 1000);
    updateMessage();
}